import Image from "next/image";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

import type { TPost } from "../types/posts";

interface IPost {
  posts: TPost[];
}

const HTML_TAGS_REGEX = /(&nbsp;|&#8211;|(<([^>]+)>))/gi;
const WHITESPACE_REGEX = /\s+/;

export const News = ({ posts }: IPost) => {
  const { t, lang } = useTranslation("common");
  return (
    <div className="bg-gray-50 pt-4">
      <div className="text-center text-3xl">{t("news")}</div>
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center py-6 lg:px-8 lg:py-8">
        {posts.map((post) => {
          const publishedDate = new Date(post.date).toLocaleString("pl-PL");
          const descriptionAll = post.content.replace(HTML_TAGS_REGEX, "");
          const description = descriptionAll
            .split(WHITESPACE_REGEX)
            .slice(0, 20)
            .join(" ");
          return (
            <div
              className="m-1 min-h-full max-w-sm rounded-lg border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800"
              key={post.databaseId}
            >
              <Link href={`news/${post.slug}`}>
                <Image
                  alt={post?.title}
                  className="rounded-t-lg"
                  height="500"
                  src={post.featuredImage?.node.sourceUrl}
                  width="954"
                />
              </Link>
              <time className="pl-5 text-sm text-white">{publishedDate}</time>
              <div className="px-5 pt-2 pb-4">
                <Link href={`news/${post.slug}`}>
                  <h5 className="mb-2 font-bold text-2xl text-gray-900 tracking-tight dark:text-white">
                    {post?.title}
                  </h5>
                </Link>
                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                  {description} ...
                </p>
                <a
                  className="inline-flex items-center rounded-lg bg-blue-700 px-3 py-2 text-center font-medium text-sm text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:focus:ring-blue-800 dark:hover:bg-blue-700"
                  href={`${lang === "en" ? "" : lang}/news/${post.slug}`}
                >
                  {t("seeMore")}
                  <svg
                    aria-hidden="true"
                    className="-mr-1 ml-2 h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      fillRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
